import React from 'react'
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { createTheme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ThemeProvider} from "@mui/material/styles";

import ConnectedSeller from './ConnectedSeller'

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
   
    appBar: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  
  }));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};



function Seller(props) {

    const classes = useStyles();
    const theme = useTheme();

    function SimpleTabs() {
      const classes = useStyles();
      const [value, setValue] = React.useState(0);
    
      const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
      return (
        <div className={classes.root}>
         <ThemeProvider theme={materialTheme}> 
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" >
              <Tab label="Connected Sellers"  />
              <Tab label="Available Sellers"  />
              <Tab label="Products"  />
            </Tabs>
         
          <TabPanel component={'div'} value={value} index={0} style={{padding:'0px'}}>
            
            <ConnectedSeller/>
            
          </TabPanel>
          <TabPanel value={value} index={1}>
           
          </TabPanel>
          <TabPanel value={value} index={2}>
           
          </TabPanel>
          </ThemeProvider>
        </div>
      );
    }
    
    return (
      <div>
          <CssBaseline />
          <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={props.handleDrawerToggle}
                className={classes.menuButton}
                size="large">
                  <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap>
                  Seller
              </Typography>
              </Toolbar>
          </AppBar>
          
          {SimpleTabs()}
         
      </div>
    );
}

export default Seller